export default "__VITE_ASSET__qROVGZF1__"